import { Text, Container, ActionIcon, Group, rem } from "@mantine/core";
import {
  IconBrandTwitter,
  IconBrandYoutube,
  IconBrandInstagram,
  IconBrandFacebook,
} from "@tabler/icons";
import Image from "next/image";
import classes from "../styles/FooterLinks.module.css";
const data = [
  {
    title: "חברה",
    links: [
      {
        label: "הורדת האפליקציה",
        link: "https://play.google.com/store/apps/details?id=com.eeefg.QuickTor&pcampaignid=web_share",
      },
      { label: "מחירון", link: "/pricing" },
      {
        label: "להרשמה",
        link: "https://app.quicktor.co.il/MainPageToConnect/CreateBusinessAccount",
      },
    ],
  },
  // {
  //   title: 'מוצר',
  //   links: [
  //     { label: 'Contribute', link: '#' },
  //     { label: 'Media assets', link: '#' },
  //     { label: 'Changelog', link: '#' },
  //     { label: 'Releases', link: '#' },
  //   ],     
  // },
  {
    title: "צרו קשר",
    links: [
      { label: "צור קשר", link: "/contact" },
      { label: "מייל", link: "mailto:em2993@support.quicktor.co.il" },
      { label: "טלפון", link: "tel:0557259188" },
    ],
  },
  {
    title: "משפטי",
    links: [
      { label: "תנאי שימוש", link: "/TermsOfService" },
      { label: "מדיניות פרטיות", link: "/PrivacyPolicy" },
      { label: "הצהרת נגישות", link: "/AccessibilityStatement" },
    ],
  },
];

export function FooterLinks() {
  const groups = data.map((group) => {
    const links = group.links.map((link, index) => (
      <Text key={index} className={classes.link} component="a" href={link.link}>
        {link.label}
      </Text>
    ));

    return (
      <div className={classes.wrapper} key={group.title}>
        <Text className={classes.title}>{group.title}</Text>
        {links}
      </div>
    );
  });

  return (
    <footer className={classes.footer}>
      <Container className={classes.inner}>
        <div className={classes.logo}>
          {/* <MantineLogo size={30} /> */}
          <div>
            <Image
              src="/logo-no-background.svg"
              width={200}
              height={100}
              alt="לוגו QuickTor - המילה QuickTor בצבע כחול עם אייקון חץ מהיר, המסמל תור מהיר וזריז"
            />
          </div>
        </div>
        <div className={classes.groups}>{groups}</div>
      </Container>
      <Container className={classes.afterFooter}>
        <Group
          gap={0}
          className={classes.social}
          justify="flex-end"
          wrap="nowrap"
        >
          {/* <ActionIcon size="lg" color="gray" variant="subtle">
            <IconBrandTwitter
              style={{ width: rem(18), height: rem(18) }}
              stroke={1.5}
            />
          </ActionIcon> */}
          <ActionIcon
            size="lg"
            color="gray"
            variant="subtle"
            component="a"
            href={"https://www.instagram.com/quick_tor"}
          >
            <IconBrandInstagram
              style={{ width: rem(18), height: rem(18) }}
              stroke={1.5}
            />
          </ActionIcon>
          <ActionIcon
            component="a"
            size="lg"
            color="gray"
            variant="subtle"
            href={"https://www.facebook.com/profile.php?id=61558413038387"}
          >
            <IconBrandFacebook
              style={{ width: rem(18), height: rem(18) }}
              stroke={1.5}
            />
          </ActionIcon>
        </Group>
        © {new Date().getFullYear()}. כל הזכויות שמורות על ידי QuickTor{" "}
      </Container>
    </footer>
  );
}
